module.exports = __webpack_public_path__ + "static/images/qrcode.4bb97138.jpg";